import { SelectedRow } from '#types/grid';

export function onRowSelect<T>(event: any): SelectedRow<T> {
  let selectionType: 'single' | 'double' | 'context' | 'multiple' = 'single';

  if (Array.isArray(event.data)) {
    return {
      selectionType: 'multiple',
      data: event.data[0] as T,
      index: null,
      type: event.type,
    };
  } else if (event.originalEvent.originalEvent) {
    const originalEvent = event.originalEvent.originalEvent;

    if (originalEvent.type === 'click') {
      selectionType = 'single';
    } else if (originalEvent.type === 'dblclick') {
      selectionType = 'double';
    } else if (originalEvent.type === 'contextmenu') {
      selectionType = 'context';
    }

    return {
      selectionType,
      data: event.data as T,
      index: event.index,
      type: 'row',
    };
  } else {
    if (event.originalEvent.type === 'click') {
      selectionType = 'single';
    } else if (event.originalEvent.type === 'dblclick') {
      selectionType = 'double';
    } else if (event.originalEvent.type === 'contextmenu') {
      selectionType = 'context';
    }

    return {
      selectionType,
      data: event.data as T,
      index: event.index,
      type: event.type,
    };
  }
}
